import * as Alert from '@/components/ui/alert'
import { IconButton } from '@/components/ui/icon-button'
import type { PoentialHighQuality } from '@hvf/contracts'
import { A } from '@solidjs/router'
import { ArrowRight, Star } from 'lucide-solid'
import { Flex, Grid } from 'styled-system/jsx'

export default function (props: {
  poentialHighQuality: PoentialHighQuality & {
    setup: {
      id: string
      symbol: string | null
      title: string | null
    }
  }
}) {
  return (
    <Alert.Root
      border="none"
      p={4}
    >
      <Alert.Indicator asChild={(props) => <Star {...props} />} />
      <Alert.Content width="100%">
        <Grid gridTemplateColumns="1fr auto">
          <Grid>
            <Alert.Title>{props.poentialHighQuality.setup.symbol}</Alert.Title>
            <Alert.Description>{props.poentialHighQuality.message || props.poentialHighQuality.setup.title}</Alert.Description>
          </Grid>
          <Flex
            flexDirection="column"
            justifyContent="end"
          >
            <A href={`/setups/${props.poentialHighQuality.setup_id}`}>
              <IconButton
                height="6"
                width="6"
                colorPalette="tscGreen"
                variant="plain"
              >
                <ArrowRight />
              </IconButton>
            </A>
          </Flex>
        </Grid>
      </Alert.Content>
    </Alert.Root>
  )
}
